import { Title } from '@angular/platform-browser';
import { AvailableToPromiseComponent } from './available-to-promise/available-to-promise.component';
import { TableSectionContainerComponent } from './../../table-section-container/table-section-container.component';
import { KeyValue } from '@angular/common';
import { AdditionalInformationParsed } from './../../../apps/shoppingCart/interfaces/configuration';
import { ReportService } from './../../../apps/report/report.service';
import { filter } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { RecordPageComponent } from './../record-page.component';
import {
  EventType,
  RecordLine,
  RecordModel,
} from 'src/app/layout/record-model';
import { LayoutService } from 'src/app/layout/layout.service';
import {
  Module,
  ModuleButton,
  Section,
  SectionType,
} from './../../../models/module-structure';
import { ModuleStructure } from 'src/app/models/module-structure';
import { Component, Input, OnInit } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import * as g from 'src/app/globals';
import { Router, ActivatedRoute } from '@angular/router';
import { WizardFilterSectionComponent } from '@app/layout/sections/wizard-filter-section/wizard-filter-section.component';
import { ScheduleSuggestionsComponent } from './schedule-suggestions/schedule-suggestions.component';
import { TableSectionComponent } from '@app/layout/sections/table-section/table-section.component';
import { PriceHistoryComponent } from './price-history/price-history.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { LineAttachmentsComponent } from './line-attachments/line-attachments.component';

@Component({
  selector: 'app-custom-buttons',
  templateUrl: './custom-buttons.component.html',
  styleUrls: ['./custom-buttons.component.less'],
})
export class CustomButtonsComponent implements OnInit {
  @Input() moduleStructure: ModuleStructure;
  @Input() buttons: ModuleButton[];
  @Input() recordModel: RecordModel;
  @Input() recordLine: RecordLine;
  @Input() recordPage: RecordPageComponent;
  @Input() forSection = false;

  forLine: number;
  get LineId(): number {
    if (
      this.section == null ||
      this.recordLine == null ||
      this.recordLine.Properties == null
    ) {
      this.forLine = -1;
      return -1;
    }

    if (this.section.KeyPropertyName == '') {
      this.section.KeyPropertyName = 'LineNum';
    }

    const keyProp = this.recordLine.Properties.find(
      (prop) => prop.Name === this.section.KeyPropertyName
    );
    //if (keyProp == null) {
    this.forLine = this.recordLine.Id;
    //} else {
    //  this.forLine = keyProp.ValueAsObject;
    //}

    return this.forLine;
  }

  @Input() renderBeforeContent = false;
  @Input() reportGuid = '';
  @Input() forReport = false;
  @Input() sectionId: number;
  section: Section;
  @Input() dataSet: any[];
  @Input() isCardView = false;
  buttonsToDisplay: ModuleButton[];
  @Input() setOfCheckedId = new Set<number>();

  constructor(
    private layoutService: LayoutService,
    private reportService: ReportService,
    private drawerService: NzDrawerService,
    private message: NzMessageService,
    private router: Router,
    private modal: NzModalService,
    private notificationService: NzNotificationService
  ) {}

  ngOnInit(): void {
    //console.log(this.LineId);
    //console.log(this.moduleStructure.buttons);
    if (this.forSection) {
      this.section = this.moduleStructure.module.Sections.find(
        (sec) => sec.Id === this.sectionId
      );
    } else {
      this.section = undefined;
    }
    this.buttonsToDisplay = [];
    this.moduleStructure.buttons.forEach((element) => {
      let displayValidation = this.displayValidation(
        element,
        this.moduleStructure.module,
        this.recordModel,
        this.LineId
      );
      if (displayValidation) {
        this.buttonsToDisplay.push(element);
      }
    });

    this.buttonsToDisplay.forEach((element) => {
      if (
        element.OptionsSQLStatementId != null &&
        element.OptionsSQLStatementId !== undefined &&
        element.OptionsSQLStatementId !== 0
      ) {
        this.layoutService
          .executeQuery(element.OptionsSQLStatementId, undefined)
          .subscribe((d: any) => {
            if (d === null || d === undefined) {
              return;
            }
            element.Options = d;
          });
      }
    });
  }

  executeCustomAction(moduleButton: ModuleButton, additionalCode: string = '') {
    moduleButton.IsLoading = true;
    let tempModuleButton = LayoutService.HardCopyObject(moduleButton);
    if (additionalCode !== '') {
      tempModuleButton.AdditionalInformationParsed.CustomActionCode =
        tempModuleButton.AdditionalInformationParsed.CustomActionCode +
        '_' +
        additionalCode;
    }

    if (
      moduleButton.AdditionalInformationParsed.CustomActionCode ===
      'SUBMIT_NEW_VERSION'
    ) {
      this.recordPage.submitObject(false, false, false, true, (d) => {
        this.recordPage.submitting = false;
        this.recordPage.submittingModel = false;
        moduleButton.IsLoading = false;
        tempModuleButton.IsLoading = false;
        if (!d.Has_Error) {
          console.log(d);
          this.recordPage.isLoading = true;
          /*this.notificationService.success(
            this.layoutService.translate('Success'),
            this.layoutService.translate(`Operation completed successfully`) +
              (d.DocumentNumber == null ? '' : ` , No. #${d.DocumentNumber}`)
          );*/
          this.recordPage.recordId = d.Resault_Value;
          //this.recordPage.loadRecordData();
          const url = this.router.url;
          const match = url.match(/module-list\/([^/]+)/);
          const moduleId = match ? match[1] : null;

          this.router.navigate([
            `/apps/${
              url.indexOf('inventory') > -1 ? 'inventory' : 'crm'
            }/module-list/${moduleId}/0`,
            { selectedId: d.Resault_Value, fromDraft: false },
          ]);
          return false;
        } else {
          //this.message.create('error', d.Error_Message);
          return true;
        }
      });
    } else {
      if (tempModuleButton.AdditionalInformationParsed.SubmitBeforeExecute) {
        this.recordPage.submitObject(false, false, false, false, (d) => {
          if (!d.Has_Error) {
            this.executeCustomActionInternal(moduleButton, tempModuleButton);
            return false;
          } else {
            return true;
          }
        });
      } else {
        this.executeCustomActionInternal(moduleButton, tempModuleButton);
      }
    }
  }

  executeCustomActionInternal(
    baseModuleButton: ModuleButton,
    moduleButton: ModuleButton
  ) {
    if (
      moduleButton.AdditionalInformationParsed.CustomActionCode ===
      'DELIVER_SCHEDULE_ALL'
    ) {
      //for SONAS
      baseModuleButton.IsLoading = false;

      let scheduleSuggestions = [];
      let index = 1;

      this.recordModel.Categories.find(
        (c) => c.Id === 'Document_Lines'
      ).Lines.forEach((recordLine) => {
        if (recordLine === undefined) {
          recordLine = this.recordModel.Categories.find(
            (c) => c.Id === 'Document_Lines'
          ).Lines.find((l) => l.Id === this.LineId);
        }

        let treeTypeProp = recordLine.Properties.find(
          (p) => p.Name === 'TreeType'
        );
        let treeType = treeTypeProp ? treeTypeProp.ValueAsObject : null;

        if (treeType !== 'iIngredient' && treeType !== 'I') {
          let scheduleSuggestionsStr = recordLine.Properties.find(
            (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE'
          ).ValueAsObject;

          let scheduleSuggestion = JSON.parse(scheduleSuggestionsStr);
          scheduleSuggestion.lineIndex = index++;
          scheduleSuggestions.push(scheduleSuggestion);
        } else {
          index++;
        }
      });

      const drawerRef = this.drawerService.create({
        nzContent: ScheduleSuggestionsComponent,
        nzWrapClassName: 'drawer-size-3x',
        nzContentParams: {
          scheduleSuggestionsAll: scheduleSuggestions,
          allData: true,
        },
        nzTitle: 'Delivery Schedule Summary',
      });

      drawerRef.afterOpen.subscribe(() => {
        const instance = drawerRef.getContentComponent();
        if (instance && instance.okButtonClicked) {
          instance.okButtonClicked.subscribe(() => {
            drawerRef.close();
          });
        }
        if (instance && instance.cancelButtonClicked) {
          instance.cancelButtonClicked.subscribe(() => {
            drawerRef.close();
          });
        }
      });
    } else if (
      moduleButton.AdditionalInformationParsed.CustomActionCode ===
      'DELIVER_SCHEDULE'
    ) {
      baseModuleButton.IsLoading = false;
      //for SONAS

      /*let recordLine = this.recordModel.Categories.find(
        (c) => c.Id === 'Document_Lines'
      ).Lines.find(
        (l) =>
          l.Properties.find((p) => p.Name === 'LineNum').ValueAsObject ===
          this.LineId
      );
      if (recordLine === undefined) {*/
      let recordLine = this.recordModel.Categories.find(
        (c) => c.Id === 'Document_Lines'
      ).Lines.find((l) => l.Id === this.LineId);
      //}

      /*let recordLine = this.recordModel.Categories.find(
        (c) => c.Id === 'Document_Lines'
      ).Lines.find((l) => l.Id === this.LineId);*/

      let scheduleSuggestionsStr = recordLine.Properties.find(
        (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE'
      ).ValueAsObject;

      if (scheduleSuggestionsStr == '' || scheduleSuggestionsStr == null) {
        this.message.error(
          'There are no delivery schedule data for this line.'
        );
        return;
      }

      let scheduleSuggestions = JSON.parse(scheduleSuggestionsStr);

      const drawerRef = this.drawerService.create({
        nzContent: ScheduleSuggestionsComponent,
        nzWrapClassName: 'drawer-size-3x',
        nzContentParams: {
          scheduleSuggestions: scheduleSuggestions,
          recordLine: recordLine,
          recordModel: this.recordModel,
          line: this.LineId,
        },
        nzTitle: 'Delivery Schedule',
      });

      drawerRef.afterOpen.subscribe(() => {
        const instance = drawerRef.getContentComponent();
        if (instance && instance.okButtonClicked) {
          instance.okButtonClicked.subscribe(() => {
            const instance1 = drawerRef.getContentComponent();
            console.log(
              'Filter button clicked:',
              instance1.scheduleSuggestions
            );

            recordLine.Properties.find(
              (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE'
            ).ValueAsObject = JSON.stringify(instance1.scheduleSuggestions);

            const lineShipDate = recordLine.Properties.find(
              (p) => p.Name === 'ShipDate'
            );
            if (lineShipDate != null && lineShipDate !== undefined) {
              this.layoutService.triggerFieldValueChanged({
                recordModel: this.recordModel,
                recordProperty: lineShipDate,
                formId: '',
                line: this.LineId,
                sectionTagName: 'Document_Lines',
                moduleStructure: this.moduleStructure,
                internalTrigger: true,
              });
            }
            drawerRef.close();

            this.layoutService.submitDeliverSchedule.emit(this.LineId);
          });
        }
        if (instance && instance.cancelButtonClicked) {
          instance.cancelButtonClicked.subscribe(() => {
            drawerRef.close();
          });
        }
      });
    } else if (
      moduleButton.AdditionalInformationParsed.CustomActionCode ===
      'PRICE_HISTORY'
    ) {
      baseModuleButton.IsLoading = false;
      let documentCatLine = this.recordModel.Categories.find(
        (c) => c.Id === 'Documents'
      ).Lines[0];

      let cardCode = documentCatLine.Properties.find(
        (p) => p.Name === 'CardCode'
      ).ValueAsObject;

      let recordLine = this.recordModel.Categories.find(
        (c) => c.Id === 'Document_Lines'
      ).Lines.find((l) => l.Id === this.LineId);

      let itemCode = recordLine.Properties.find(
        (p) => p.Name === 'ItemCode'
      ).ValueAsObject;

      const drawerRef = this.drawerService.create({
        nzContent: PriceHistoryComponent,
        nzWrapClassName: 'drawer-size-3x',
        nzTitle: 'Price History',
        nzContentParams: {
          cardCode: cardCode,
          itemCode: itemCode,
        },
      });
    } else if (
      moduleButton.AdditionalInformationParsed.CustomActionCode ===
      'LINE_ATTACHMENT'
    ) {
      baseModuleButton.IsLoading = false;

      let recordLine = this.recordModel.Categories.find(
        (c) => c.Id === this.section.XmlTagName
      ).Lines.find((l) => l.Id === this.LineId);

      //LINE_ATT_DTL
      let recordProperty = recordLine.Properties.find(
        (p) => p.Name === 'U_LINE_ATT_DTL'
      );

      const drawerRef = this.drawerService.create<
        LineAttachmentsComponent,
        {
          attachmentsText: string;
          readOnly: boolean;
          isImage: boolean;
          allowUploadFile: boolean;
          allowSignature: boolean;
          allowUsingCamera: boolean;
        },
        string
      >({
        nzContent: LineAttachmentsComponent,
        nzWrapClassName: 'drawer-size-3x',
        nzTitle: 'line-attachments',
        nzContentParams: {
          attachmentsText: recordProperty.Value || '', // <-- your stored string
          readOnly: false,
          isImage: true, // or true if you want image mode
          allowUploadFile: true,
          allowSignature: false,
          allowUsingCamera: true,
        },
      });

      drawerRef.afterClose.subscribe((result: string) => {
        if (typeof result === 'string') {
          recordProperty.ValueAsObject = result;
          recordProperty.Value = result;
        }
      });
    } else if (
      moduleButton.AdditionalInformationParsed.CustomActionCode === 'ATP_REPORT'
    ) {
      baseModuleButton.IsLoading = false;
      /*let documentCatLine = this.recordModel.Categories.find(
        (c) => c.Id === 'Documents'
      ).Lines[0];*/

      /*let cardCode = documentCatLine.Properties.find(
        (p) => p.Name === 'CardCode'
      ).ValueAsObject;*/

      /*let recordLine = this.recordModel.Categories.find(
        (c) => c.Id === 'Document_Lines'
      ).Lines.find(
        (l) =>
          l.Properties.find((p) => p.Name === 'LineNum').ValueAsObject ===
          this.LineId
      );
      if (recordLine === undefined) {*/
      let recordLine = this.recordModel.Categories.find(
        (c) => c.Id === 'Document_Lines'
      ).Lines.find((l) => l.Id === this.LineId);
      //}

      let itemCode = recordLine.Properties.find(
        (p) => p.Name === 'ItemCode'
      ).ValueAsObject;

      let warehouse = recordLine.Properties.find(
        (p) => p.Name === 'WarehouseCode'
      ).ValueAsObject;

      const drawerRef = this.drawerService.create({
        nzContent: AvailableToPromiseComponent,
        nzWrapClassName: 'drawer-size-3x',
        nzTitle: 'Available to promise',
        nzContentParams: {
          //cardCode: cardCode,
          itemCode: itemCode,
          warehouse: warehouse,
        },
      });
    } else if (moduleButton.AdditionalInformationParsed.ShowConfirmation) {
      this.modal.confirm({
        nzTitle: this.layoutService.translate(
          moduleButton.AdditionalInformationParsed.ConfirmationMessage
        ),
        nzOkText: this.layoutService.translate('Yes'),
        nzCancelText: this.layoutService.translate('No'),
        nzAutofocus: 'cancel',
        nzOnOk: () => {
          baseModuleButton.IsLoading = true;
          this.doTheExecution(
            moduleButton.AdditionalInformationParsed.CustomActionCode,
            moduleButton,
            () => {
              baseModuleButton.IsLoading = false;
            }
          );
        },
      });
    } else if (
      moduleButton.AdditionalInformationParsed.CustomFieldSectionId !== 0
    ) {
      const drawerRef = this.drawerService.create({
        nzContent: WizardFilterSectionComponent,
        nzWrapClassName: 'drawer-size-3x',
        nzContentParams: {
          sectionId:
            moduleButton.AdditionalInformationParsed.CustomFieldSectionId,
          embdedSection: true,
        },
      });

      drawerRef.afterOpen.subscribe(() => {
        const instance = drawerRef.getContentComponent();
        if (instance && instance.okButtonClicked) {
          instance.okButtonClicked.subscribe(() => {
            const instance1 = drawerRef.getContentComponent();
            console.log('Filter button clicked:', instance1.filterFieldsVal);
            this.recordModel.UnkownKeys = [];
            if (instance1.filterFieldsVal !== undefined) {
              instance1.filterFieldsVal.forEach((field) => {
                this.recordModel.UnkownKeys.push({
                  Name: field.FieldName,
                  ValueAsObject: field.Value,
                });
              });

              baseModuleButton.IsLoading = true;
              this.doTheExecution(
                moduleButton.AdditionalInformationParsed.CustomActionCode,
                moduleButton,
                () => {
                  baseModuleButton.IsLoading = false;
                  drawerRef.close();
                }
              );
            }
          });
        }
        if (instance && instance.cancelButtonClicked) {
          instance.cancelButtonClicked.subscribe(() => {
            drawerRef.close();
          });
        }
      });
    } else {
      baseModuleButton.IsLoading = true;
      this.doTheExecution(
        moduleButton.AdditionalInformationParsed.CustomActionCode,
        moduleButton,
        () => {
          baseModuleButton.IsLoading = false;
        }
      );
    }
  }

  executeReportCustomAction(moduleButton: ModuleButton) {
    if (moduleButton.AdditionalInformationParsed.ShowConfirmation) {
      this.modal.confirm({
        nzTitle: this.layoutService.translate(
          moduleButton.AdditionalInformationParsed.ConfirmationMessage
        ),
        nzOkText: this.layoutService.translate('Yes'),
        nzCancelText: this.layoutService.translate('No'),
        nzOnOk: () => {
          moduleButton.IsLoading = true;
          this.doTheExecution(
            moduleButton.AdditionalInformationParsed.CustomActionCode,
            moduleButton,
            () => {
              moduleButton.IsLoading = false;
            }
          );
        },
      });
    } else {
      moduleButton.IsLoading = true;
      this.doTheExecution(
        moduleButton.AdditionalInformationParsed.CustomActionCode,
        moduleButton,
        () => {
          moduleButton.IsLoading = false;
        }
      );
    }
  }

  selectionChanged(selectedIds: any[], customActionCode: string) {
    // no need to implement
  }

  submitSelection(selectedIds: any[], customActionCode: string) {
    let items = selectedIds.toString();
    try {
      items = selectedIds.join(',');
    } catch {}
    RecordModel.ExecuteCustomAction(
      customActionCode + '_SELECTED_' + items,
      this.layoutService,
      this.recordModel,
      '',
      this.moduleStructure,
      this.drawerService,
      this,
      '',
      this.router,
      () => {}
    );
  }

  doTheExecution(
    customActionCode: string,
    moduleButton: ModuleButton,
    callback: () => void
  ) {
    if (this.forReport) {
      this.reportService
        .ExecuteCustomReportAction(this.reportGuid, customActionCode)
        .subscribe((d) => {
          //console.log(d);
          moduleButton.IsLoading = false;
        });
    } else if (this.forSection) {
      const section = this.moduleStructure.module.Sections.find(
        (sec) => sec.Id === this.sectionId
      );
      if (
        section.Type === 3 &&
        this.recordModel.TableSections !== undefined &&
        !moduleButton.AdditionalInformationParsed.ExecuteOnClientSide
      ) {
        if (
          this.recordModel.TableSections[section.XmlTagName] == null ||
          this.recordModel.TableSections[section.XmlTagName].filter(
            (row) => row.ITMSelected === true
          ) == null ||
          this.recordModel.TableSections[section.XmlTagName].filter(
            (row) => row.ITMSelected === true
          ).length === 0
        ) {
          this.message.info('There is no data to process');
          moduleButton.IsLoading = false;
          return;
        }
        /*if (
          this.recordModel.UnkownKeys == null ||
          this.recordModel.UnkownKeys.find((p) => p.Name === 'DataToProcess') ==
            null
        ) {
          this.recordModel.UnkownKeys.push({
            Name: 'DataToProcess',
            ValueAsObject: '',
          });
        }*/

        /*this.recordModel.UnkownKeys.find(
          (p) => p.Name === 'DataToProcess'
        ).ValueAsObject = JSON.stringify(
          this.recordModel.TableSections[section.XmlTagName].filter(
            (row) => row.ITMSelected === true
          )
        );*/

        RecordModel.ExecuteCustomAction(
          customActionCode,
          this.layoutService,
          this.recordModel,
          '',
          this.moduleStructure,
          this.drawerService,
          this,
          JSON.stringify(
            this.recordModel.TableSections[section.XmlTagName].filter(
              (row) => row.ITMSelected === true
            )
          ),
          this.router,
          callback
        );
      } else if (moduleButton.AdditionalInformationParsed.ExecuteOnClientSide) {
        const section = this.moduleStructure.module.Sections.find(
          (sec) => sec.Id === this.sectionId
        );

        const args = {
          module: this.moduleStructure.module,
          section,
          recordModel: this.recordModel,
          baseUrl: g.apiBaseUrl,
          suffixUrl: g.getUrlSuffix(),
        };

        const customEvent = new CustomEvent('BWEBExecuteClientSideFuntion', {
          detail: args,
          bubbles: true,
          cancelable: false,
        });

        document.dispatchEvent(customEvent);
      } else {
        const section = this.moduleStructure.module.Sections.find(
          (sec) => sec.Id === this.sectionId
        );

        if (moduleButton.AdditionalInformationParsed.WorkingOnSelectedLines) {
          let selectedIds = Array.from(this.setOfCheckedId);
          RecordModel.ExecuteCustomAction(
            customActionCode,
            this.layoutService,
            this.recordModel,
            section.XmlTagName + '|' + selectedIds.join(','),
            this.moduleStructure,
            this.drawerService,
            this,
            '',
            this.router,
            callback
          );
        } else {
          RecordModel.ExecuteCustomAction(
            customActionCode,
            this.layoutService,
            this.recordModel,
            section.XmlTagName + '|' + this.LineId,
            this.moduleStructure,
            this.drawerService,
            this,
            '',
            this.router,
            callback
          );
        }
      }
    } else {
      if (moduleButton.AdditionalInformationParsed.ExecuteOnClientSide) {
        const args = {
          action: customActionCode,
          module: this.moduleStructure.module,
          section: undefined,
          recordModel: this.recordModel,
          baseUrl: g.apiBaseUrl,
          suffixUrl: g.getUrlSuffix(),
        };

        const customEvent = new CustomEvent('BWEBExecuteClientSideFuntion', {
          detail: args,
          bubbles: true,
          cancelable: false,
        });

        document.dispatchEvent(customEvent);

        callback();
      } else {
        RecordModel.ExecuteCustomAction(
          customActionCode,
          this.layoutService,
          this.recordModel,
          '',
          this.moduleStructure,
          this.drawerService,
          this,
          '',
          this.router,
          callback
        );
      }
    }
    // this.layoutService
    //   .pushDataToBackend(
    //     JSON.stringify(this.recordModel),
    //     customActionCode
    //   )
    //   .subscribe((e: any) => {
    //     callback();

    //     const actionResult = JSON.parse(e.Resault_Value);
    //     if (actionResult.ResultType === 1) {
    //       const result = actionResult.Result as any[];
    //       for (const changedProperty of result) {
    //         const category = this.recordModel.Categories.find(
    //           (c) => c.Id === changedProperty.CategoryId
    //         );

    //         const line = category.Lines.find(
    //           (l) => l.Id === changedProperty.LineId
    //         );

    //         const property = line.Properties.find(
    //           (p) => p.Name === changedProperty.PropertyName
    //         );

    //         LayoutService.setValue(
    //           property,
    //           changedProperty.Value,
    //           this.layoutService,
    //           this.recordModel,
    //           changedProperty.LineId,
    //           changedProperty.CategoryId,
    //           this.moduleStructure
    //         );
    //       }
    //     } else if (actionResult.ResultType === 0) {
    //       const result = actionResult.Result as any;
    //       RecordPageComponent.openRecordPage(this.drawerService, {
    //         actionType: result.EventType,
    //         drawerTitle: this.layoutService.translate(`Execute Action`),
    //         inDrawer: true,
    //         moduleId: result.ModuleId,
    //         moduleActionType: result.ActionType,
    //         sourceModuleId: result.SourceObject,
    //         parentComponent: this,
    //         recordId:
    //           result.EventType === 'Edit'
    //             ? result.SelectedId.toString()
    //             : undefined,
    //         sourceRecordId:
    //           result.EventType !== 'Edit'
    //             ? result.SelectedId.toString()
    //             : undefined,
    //         recordModel: undefined,
    //         customActionCode: result.CustomActionCode,
    //       });
    //     } else if (actionResult.ResultType === 2) {
    //       const result = actionResult.Result as any;
    //       if (result.Success) {
    //         this.message.success(
    //           this.layoutService.translate(
    //             'Your operation has been completed successfully!'
    //           ) +
    //           ' ' +
    //           result.Msg
    //         );

    //         if (result.Url != null) {
    //           window.open(g.apiBaseUrl + result.Url + '&' + g.getUrlSuffix());
    //         }

    //         if (result.Reload) {
    //           this.reloadModel();
    //         }
    //       } else {
    //         this.message.error(result.Msg);
    //       }
    //     } else if (actionResult.ResultType === 3) {
    //       const result = actionResult.Result as any;
    //       if (result.Success) {
    //         this.message.success(
    //           this.layoutService.translate(
    //             'Your operation has been completed successfully!'
    //           ) +
    //           ' ' +
    //           result.Msg
    //         );
    //         this.recordPage.backButtonClicked.emit();
    //         this.layoutService.refreshListEmitter.emit();
    //       } else {
    //         this.message.error(result.Msg);
    //       }
    //     }
    //   });
  }

  reloadModel() {
    this.recordPage.isLoading = true;
    this.recordPage.moduleStructure = undefined;
    this.recordPage.recordModel = undefined;
    this.recordPage.ngOnInit();
  }

  recordPageDrawerClosed() {}

  linkedObjectSubmitted(result, args) {
    //console.log(args, result);
    RecordPageComponent.openRecordPage(this.drawerService, {
      moduleId: args.moduleId,
      actionType: 'Edit',
      drawerTitle: args.drawerTitle,
      inDrawer: true,
      parentComponent: args.parentComponent,
      recordId: result,
      recordModel: undefined,
    });
  }

  displayValidation(
    moduleButton: ModuleButton,
    module: Module,
    recordModel: RecordModel,
    lineIndex: number
  ): boolean {
    if (
      moduleButton.AdditionalInformationParsed.AllowInAddMode &&
      ((lineIndex !== -1 &&
        moduleButton.AdditionalInformationParsed.OnLineLevel) ||
        (lineIndex === -1 &&
          !moduleButton.AdditionalInformationParsed.OnLineLevel)) &&
      recordModel.EventType === EventType.Create
    ) {
      return this.checkConditions(module, moduleButton, recordModel, lineIndex);
    }

    if (
      moduleButton.AdditionalInformationParsed.AllowInEditMode &&
      ((lineIndex !== -1 &&
        moduleButton.AdditionalInformationParsed.OnLineLevel) ||
        (lineIndex === -1 &&
          !moduleButton.AdditionalInformationParsed.OnLineLevel)) &&
      recordModel.EventType === EventType.Update
    ) {
      return this.checkConditions(module, moduleButton, recordModel, lineIndex);
    }

    if (
      moduleButton.AdditionalInformationParsed.AllowInViewMode &&
      ((lineIndex !== -1 &&
        moduleButton.AdditionalInformationParsed.OnLineLevel) ||
        (lineIndex === -1 &&
          !moduleButton.AdditionalInformationParsed.OnLineLevel)) &&
      recordModel.EventType === EventType.View
    ) {
      return this.checkConditions(module, moduleButton, recordModel, lineIndex);
    }

    return false;
  }

  checkConditions(
    module: Module,
    moduleButton: ModuleButton,
    recordModel: RecordModel,
    lineIndex: number
  ): boolean {
    moduleButton.IsLoading = false;
    if (
      moduleButton.AdditionalInformationParsed.DisplayConditions == null ||
      moduleButton.AdditionalInformationParsed.DisplayConditions === ''
    ) {
      return true;
    } else {
      const conditions = JSON.parse(
        moduleButton.AdditionalInformationParsed.DisplayConditions
      );

      const keys = Object.keys(conditions);
      let conditionCheck = true;
      keys.forEach((key) => {
        const category = key.split('.')[0];
        const property = key.split('.')[1];
        const vals = conditions[key].toString().split(',');

        let section = module.Sections.find((c) => c.XmlTagName === category);

        let recordLine = recordModel.Categories.find((c) => c.Id === category)
          .Lines[0];
        if (lineIndex !== -1 && section.Type === SectionType.Lines) {
          recordLine = recordModel.Categories.find(
            (c) => c.Id === category
          ).Lines.find((l) => l.Id === lineIndex);
        }
        conditionCheck =
          conditionCheck &&
          vals.indexOf(
            recordLine.Properties.find(
              (p) => p.Name === property
            ).ValueAsObject.toString()
          ) !== -1;
      });

      return conditionCheck;
    }
  }
}

@Pipe({ name: 'buttonVisible' })
export class ButtonVisiblePipe implements PipeTransform {
  transform(
    moduleButton: ModuleButton,
    module: Module,
    recordModel: RecordModel,
    lineIndex: number
  ): boolean {
    if (
      moduleButton.AdditionalInformationParsed.AllowInAddMode &&
      ((lineIndex !== -1 &&
        moduleButton.AdditionalInformationParsed.OnLineLevel) ||
        (lineIndex === -1 &&
          !moduleButton.AdditionalInformationParsed.OnLineLevel)) &&
      recordModel.EventType === EventType.Create
    ) {
      return this.checkConditions(module, moduleButton, recordModel, lineIndex);
    }

    if (
      moduleButton.AdditionalInformationParsed.AllowInEditMode &&
      ((lineIndex !== -1 &&
        moduleButton.AdditionalInformationParsed.OnLineLevel) ||
        (lineIndex === -1 &&
          !moduleButton.AdditionalInformationParsed.OnLineLevel)) &&
      recordModel.EventType === EventType.Update
    ) {
      return this.checkConditions(module, moduleButton, recordModel, lineIndex);
    }

    if (
      moduleButton.AdditionalInformationParsed.AllowInViewMode &&
      ((lineIndex !== -1 &&
        moduleButton.AdditionalInformationParsed.OnLineLevel) ||
        (lineIndex === -1 &&
          !moduleButton.AdditionalInformationParsed.OnLineLevel)) &&
      recordModel.EventType === EventType.View
    ) {
      return this.checkConditions(module, moduleButton, recordModel, lineIndex);
    }

    return false;
  }

  checkConditions(
    module: Module,
    moduleButton: ModuleButton,
    recordModel: RecordModel,
    lineIndex: number
  ): boolean {
    moduleButton.IsLoading = false;
    if (
      moduleButton.AdditionalInformationParsed.DisplayConditions == null ||
      moduleButton.AdditionalInformationParsed.DisplayConditions === ''
    ) {
      return true;
    } else {
      const conditions = JSON.parse(
        moduleButton.AdditionalInformationParsed.DisplayConditions
      );

      const keys = Object.keys(conditions);
      let conditionCheck = true;
      keys.forEach((key) => {
        const category = key.split('.')[0];
        const property = key.split('.')[1];
        const vals = conditions[key].toString().split(',');

        let section = module.Sections.find((c) => c.XmlTagName === category);

        let recordLine = recordModel.Categories.find((c) => c.Id === category)
          .Lines[0];
        if (lineIndex !== -1 && section.Type === SectionType.Lines) {
          recordLine = recordModel.Categories.find(
            (c) => c.Id === category
          ).Lines.find((l) => l.Id === lineIndex);
        }
        conditionCheck =
          conditionCheck &&
          vals.indexOf(
            recordLine.Properties.find(
              (p) => p.Name === property
            ).ValueAsObject.toString()
          ) !== -1;
      });

      return conditionCheck;
    }
  }
}
